import { buildUrlWithAuth, RIDER_ENDPOINTS, getRiderId } from '../config/apiConfig'
import Storage from '@/shared/utils/storage'

export default {
  url() {
    const riderId = getRiderId()
    if (!riderId) return null
    return buildUrlWithAuth(RIDER_ENDPOINTS.PROFILE(riderId))
  },
  parse(raw = {}, payload = { type: '' }) {
    if (raw?.statusCode === 200) {
      const rider = raw?.data || {}
      const status = rider?.status || 'offline'
      const metadata = rider?.metadata || {}
      const isSuspended = Boolean(metadata?.isSuspended || metadata?.suspended || rider?.isSuspended)
      
      // Update local storage to keep it in sync
      Storage.save('riderStatus', status)
      const userData = Storage.get('userData') || {}
      userData.status = status
      userData.isSuspended = isSuspended
      userData.metadata = { ...(userData.metadata || {}), ...metadata }
      Storage.save('userData', userData)

      return {
        statusCode: 200,
        data: {
          isAvailable: status === 'online',
          status: status,
          isSuspended: isSuspended,
          suspendedReason: metadata?.suspendedReason || 'Votre compte est suspendu par l\'administration.',
          metadata: metadata,
          rider: rider,
        },
      }
    }

    // Fallback if not 200
    const userData = Storage.get('userData') || {}
    const riderStatus = userData?.status || Storage.get('riderStatus') || 'offline'
    const isSuspended = Boolean(userData?.isSuspended || userData?.metadata?.isSuspended || userData?.metadata?.suspended)

    return {
      statusCode: 200,
      data: {
        isAvailable: riderStatus === 'online',
        status: riderStatus,
        isSuspended: isSuspended,
        suspendedReason: userData?.metadata?.suspendedReason || 'Votre compte est suspendu par l\'administration.',
        metadata: userData?.metadata || {},
      },
    }
  },
}
